module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-wrapper"
  }, [_c('q-layout-header', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('q-toolbar', {
    staticClass: "navigation",
    attrs: {
      "color": "brand"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('logo')], 1), _vm._v(" "), (_vm.compressed) ? _c('div', {
    staticClass: "navigation--compressed"
  }, [_c('div', {
    staticClass: "navigation-subtitle"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.compressedSubtitle.link
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "navigation-title no-margin"
  }, [_vm._v(_vm._s(_vm.compressedTitle))]), _vm._v(" "), _c('div', {
    staticClass: "right-align"
  }, [(_vm.compressedUnpublishedChanges > 0) ? _c('div', {
    staticClass: "unpublished-changes"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.drag_editor.unpublished_changes")) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('add-button')], 1)]) : _c('div', [_c('q-tabs', {
    attrs: {
      "color": "brand"
    }
  }, [_vm._l((_vm.mainNavigation), function(routes) {
    return (_vm.allowedInPlan(routes.label)) ? _c(Array.isArray(routes.submenu) ?
      'q-route-tab' :
      'authenticated-navigation-item', {
        directives: [{
          name: "can",
          rawName: "v-can",
          value: (routes.credential),
          expression: "routes.credential"
        }],
        key: routes.label,
        tag: "q-route-tab",
        class: Array.isArray(routes.submenu) ? 'submenu' : '',
        attrs: {
          "slot": "title",
          "exact": "",
          "bindings": _vm.getBindings(routes),
          "to": Array.isArray(routes.submenu) ? "" : '',
          "auth": routes.auth,
          "label": Array.isArray(routes.submenu) ?
            _vm.$t('ui.menu.' + routes.label) :
            routes.label
        },
        nativeOn: {
          "click": function($event) {
            return _vm.onClick(routes)
          }
        },
        slot: "title"
      }, [(Array.isArray(routes.submenu)) ? _c('q-popover', {
        staticClass: "navigation-dropdown",
        attrs: {
          "fit": ""
        }
      }, [_c('q-tabs', {
        staticClass: "dropdown",
        attrs: {
          "align": "center",
          "color": "brand"
        }
      }, _vm._l((routes.submenu), function(subroutes) {
        return (_vm.allowedInPlan(subroutes.label)) ? _c("authenticated-navigation-item", {
          directives: [{
            name: "can",
            rawName: "v-can",
            value: (subroutes.credential),
            expression: "subroutes.credential"
          }],
          key: subroutes.label,
          tag: "q-route-tab",
          attrs: {
            "slot": "title",
            "exact": "",
            "hidden": subroutes.disabled,
            "bindings": _vm.getBindings(subroutes),
            "auth": subroutes.auth,
            "label": subroutes.label
          },
          on: {
            "click": function($event) {
              return _vm.onClick(subroutes)
            },
            "close": function($event) {
              return _vm.close()
            }
          },
          slot: "title"
        }) : _vm._e()
      }), 1)], 1) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('q-route-tab', {
    staticClass: "submenu",
    attrs: {
      "slot": "title",
      "to": "",
      "exact": ""
    },
    slot: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.menu.content_manager")) + "\n            "), _c('q-popover', {
    ref: "contentManager",
    staticClass: "navigation-dropdown",
    attrs: {
      "fit": ""
    }
  }, [_c('q-tabs', {
    staticClass: "dropdown",
    attrs: {
      "align": "center",
      "color": "brand"
    }
  }, [_vm._l((_vm.contentManager), function(routes) {
    return (_vm.allowedInPlan(routes.label)) ? _c("authenticated-navigation-item", {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: (routes.credential),
        expression: "routes.credential"
      }],
      key: routes.label,
      tag: "q-route-tab",
      attrs: {
        "slot": "title",
        "exact": "",
        "bindings": _vm.getBindings(routes),
        "auth": routes.auth,
        "label": routes.label
      },
      on: {
        "close": function($event) {
          return _vm.close()
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.onClick()
        }
      },
      slot: "title"
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-title-tab"
  }, [_vm._v("Engagement")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.businessKitLink,
      "target": "_blank"
    }
  }, [_c('q-tab', {
    staticClass: "content-start businesskit-tab"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("ui.menu.businesskits")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/bk.svg"),
      "alt": ""
    }
  })])], 1)], 2)], 1)], 1), _vm._v(" "), _c('q-route-tab', {
    staticClass: "submenu account",
    attrs: {
      "slot": "title",
      "to": "",
      "exact": ""
    },
    slot: "title"
  }, [_c('user-image', {
    attrs: {
      "firstname": _vm.currentUser.firstname,
      "lastname": _vm.currentUser.lastname,
      "email": _vm.currentUser.email == 'unknown' ? '' : _vm.currentUser.email,
      "theme": "sensual"
    }
  }), _vm._v(" "), _c('q-popover', {
    ref: "account",
    staticClass: "navigation-dropdown account-overlay dropdown",
    attrs: {
      "fit": ""
    }
  }, [_c('language-switcher'), _vm._v(" "), (_vm.userId) ? _c('q-tabs', {
    staticClass: "dropdown",
    attrs: {
      "align": "center",
      "color": "brand"
    }
  }, _vm._l((_vm.account), function(routes) {
    return (_vm.allowedInPlan(routes.label)) ? _c("authenticated-navigation-item", {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: (routes.credential),
        expression: "routes.credential"
      }],
      key: routes.label,
      tag: "q-route-tab",
      attrs: {
        "slot": "title",
        "exact": "",
        "bindings": _vm.getBindings(routes),
        "auth": routes.auth,
        "label": routes.label
      },
      on: {
        "close": function($event) {
          return _vm.close()
        }
      },
      slot: "title"
    }) : _vm._e()
  }), 1) : _vm._e()], 1)], 1)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a07c857","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/Navigation.vue
// module id = 1827
// module chunks = 0